/**
 * Builds the pre-check-in URL for a given hotel and booking.
 * Use this helper everywhere the `/pre-checkin/form` route is constructed.
 */
export const buildPreCheckInUrl = (hotelID: string, bookingID: string): string => {
  const urlOrigin = window.location.origin;
  return `${urlOrigin}/pre-checkin/form?Hotel=${hotelID}&Booking=${bookingID}`;
};
